export default [
  {
    path: '/broker',
    name: 'broker-list',
    component: () => import('@/views/broker-management/BrokerList.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Broker', active: true },
      ],
      pageTitle: 'Broker | Job Brokerage',
      rule: 'editor',
      allowAnonymous: false,
      section: 'Finance',
      group: ["admin", "agency"],
      allowedAccountTypes: ['agency'],
    },
  },
  {
    path: '/broker/create',
    name: 'broker-create',
    component: () => import('@/views/broker-management/BrokerCreate.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Broker', url: '/broker' },
        { title: 'Create Job', active: true },
      ],
      pageTitle: 'Create Broker Job',
      rule: 'editor',
      allowAnonymous: false,
      section: 'Finance',
      group: ["admin", "agency"],
      allowedAccountTypes: ['agency'],
    },
  },
  {
    path: '/broker/:job_id',
    name: 'broker-details',
    component: () => import('@/views/broker-management/BrokerDetails.vue'),
    meta: {
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Broker', url: '/broker' },
        { title: 'Job Details', active: true },
      ],
      pageTitle: 'Job Details | Broker',
      rule: 'editor',
      allowAnonymous: false,
      section: 'Finance',
      group: ["admin", "agency"],
      allowedAccountTypes: ['agency'],
    },
  },
]
